// useSetUserProducerCenterSpecificationAndWallet.tsx
import axios from "axios";
import { useAuth, UserProducerCenter } from "../../auth"; // Adjust the path to your actual auth hook
import { GetProducerCenterWalletPriceCustom, GetUserProducerCenterCustom } from "../../auth/core/_requests";


export const useSetUserProducerCenterSpecificationAndWallet = () => {
  const { saveUserProducerCenter, setProducerStatus, userProducerCenter } = useAuth();

  // Define the function within the hook
  const setUserProducerCenterSpecificationAndWallet = async () => {
    setProducerStatus("loading");
    try {
      // Fetch user producer center data
      const getUserProducerCenter = await GetUserProducerCenterCustom();
      // Check if the fetch was successful
      if (
        getUserProducerCenter.data?.isSuccess === true &&
        getUserProducerCenter.data.data?.producerCenterId
      ) {
        // Construct the UserProducerCenter object
        const userProducerCenter: UserProducerCenter = {
          producerCenterId: getUserProducerCenter.data.data.producerCenterId,
          name: getUserProducerCenter.data.data.name,
          code: getUserProducerCenter.data.data.code,
          icon: getUserProducerCenter.data.data.icon,
          isMaster: getUserProducerCenter.data.data.isMaster,
          walletPrice: 0, // Default value
        };

        // Fetch the wallet price
        const getProducerCenterWallet = await GetProducerCenterWalletPriceCustom(getUserProducerCenter.data.data.producerCenterId);

        // If the wallet price fetch is successful, update the walletPrice
        if (getProducerCenterWallet.data?.isSuccess) {
          userProducerCenter.walletPrice = getProducerCenterWallet.data.data.walletPrice;
        }

        // Save the user producer center data
        saveUserProducerCenter(userProducerCenter);
      } else if (
        getUserProducerCenter.status === 204 ||
        getUserProducerCenter.data?.isSuccess === false ||
        getUserProducerCenter.data?.data === null ||
        getUserProducerCenter.data?.data?.producerCenterId === null
      ) {
        setProducerStatus("not_exists");
      } else {
        setProducerStatus("error");
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        setProducerStatus("not_exists");
      } else {
        console.error("Error setting user producer center:", error);
        setProducerStatus("error");
      }
    }
  };

  const UpdateProducerCenterWalletPrice = async () => {
    const getProducerCenterWallet = await GetProducerCenterWalletPriceCustom(userProducerCenter?.producerCenterId ?? "");
    if (getProducerCenterWallet.data?.isSuccess) {

      if (getProducerCenterWallet.data.data.walletPrice != userProducerCenter?.walletPrice) {
        const userProducerCenterUpdate: UserProducerCenter = {
          producerCenterId: userProducerCenter?.producerCenterId,
          name: userProducerCenter?.name,
          code: userProducerCenter?.code,
          icon: userProducerCenter?.icon,
          isMaster: userProducerCenter?.isMaster,
          walletPrice: getProducerCenterWallet.data.data.walletPrice,
        };
        saveUserProducerCenter(userProducerCenterUpdate)
      }
    }
  }

  // Return the function to be used within components
  return { setUserProducerCenterSpecificationAndWallet, UpdateProducerCenterWalletPrice };
};
// export const SetUserProducerCenterSpecification = async () => {
//   const { saveUserProducerCenter } = useAuth();
//   var getUserProducerCenter = await GetUserProducerCenterNT();
//   if (getUserProducerCenter.data?.isSuccess == true) {
//     const userProducerCenter: UserProducerCenter = {
//       producerCenterId: getUserProducerCenter.data.data.producerCenterId,
//       name: getUserProducerCenter.data.data.name,
//       code: getUserProducerCenter.data.data.code,
//       icon: getUserProducerCenter.data.data.icon,
//       isMaster: getUserProducerCenter.data.data.isMaster,
//       walletPrice: 0,
//     };
//     saveUserProducerCenter(userProducerCenter);
//   }
// };

// export const SetUserProducerCenterWalletPrice = async ({
//   producerCenterId,
// }) => {
//   var getProducerCenterWallet = await GetProducerCenterWalletPriceNT(
//     producerCenterId
//   );
//   if (getProducerCenterWallet.data?.isSuccess == true) {
//     producerCenterId.walletPrice =
//       getProducerCenterWallet.data.data.walletPrice;
//   }
// };